const flow = [
  { icon: 'ri-radar-line', title: 'Ситуация', desc: 'Берём конкретную конфликтную ситуацию: реальную из практики компании или типовую из бизнеса.' },
  { icon: 'ri-search-eye-line', title: 'Анализ', desc: 'Определяем причину, участников, интересы сторон и реальную проблему, которая стоит за спором.' },
  { icon: 'ri-map-2-line', title: 'Выбор стратегии', desc: 'Подбираем подход: дать договориться, задать правила, вмешаться, провести отдельный разговор или менять систему.' },
  { icon: 'ri-chat-3-line', title: 'Разговор', desc: 'Участник проводит разговор в роли руководителя или медиатора, применяя инструменты на практике.' },
  { icon: 'ri-feedback-line', title: 'Обратная связь', desc: 'Группа и тренер дают обратную связь по коммуникации: что сработало, что можно улучшить.' },
  { icon: 'ri-loop-left-line', title: 'Повторная попытка', desc: 'Участник пробует ещё раз с учётом обратной связи, закрепляя нужную модель поведения.' },
  { icon: 'ri-file-check-line', title: 'Фиксация решения', desc: 'Переводим итог разговора в конкретные действия, сроки и ответственность — рабочую договорённость.' },
];

export default function HowPracticeGoes() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Не просто обсуждаем конфликты — тренируемся их решать
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Практическая отработка строится по циклу, который переносит навык в реальную управленческую практику
        </p>

        <div className="flex flex-wrap justify-center items-center gap-2 mb-12">
          {flow.map((f, i) => (
            <div key={f.title} className="flex items-center gap-2">
              <span className="bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">{f.title}</span>
              {i < flow.length - 1 && <i className="ri-arrow-right-line text-teal-400"></i>}
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {flow.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed">
            Для отработки используются ролевые упражнения, разбор кейсов и управленческие ситуации. Участники тренируются проводить сложные разговоры, работать с эмоциями собеседника и доводить конфликт до конкретной договорённости.
          </p>
        </div>
      </div>
    </section>
  );
}